import React from 'react';
import { useTranslation } from 'react-i18next';

const BookingPage = () => {
  const { t } = useTranslation('common');
  const bookingFormUrl = "https://playworld.no/bursdagsfeiring-barnebursdag-lekeland/";

  return (
    <div style={{ padding: 'max(88px, calc(60px + env(safe-area-inset-top))) 0 40px' }}>
      <iframe
        src={bookingFormUrl}
        style={{ width: '100%', height: '800px', border: 'none' }}
        title={t('bookingFormTitle')}
        allowFullScreen
      />
    </div>
  );
};

export default BookingPage;
